/** QSuite auth API base (OTP, profile). Set via REACT_APP_BACKEND_URL in .env */
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(
  /\/+$/,
  "",
);

/** HRLMS API base (HR dashboard, attendance, employees). */
export const HR_API_URL = (
  process.env.REACT_APP_HR_API_URL || "http://localhost:6002"
).replace(/\/+$/, "");


/** Hostels API base (hostels, rooms, allocations). */
export const HOSTELS_API_URL = (
  process.env.REACT_APP_HOSTELS_API_URL || ""
).replace(/\/+$/, "");

/** QTicket API base (ID approvals). Local default matches http://localhost:3000. */
export const QTICKET_API_URL = (
  process.env.REACT_APP_QTICKET_API_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:3000" : "")
).replace(/\/+$/, "");

export const OTP_SEND_PATH =
  process.env.REACT_APP_OTP_SEND_PATH || "/api/v1/otp/send";

export const OTP_VERIFY_PATH =
  process.env.REACT_APP_OTP_VERIFY_PATH || "/api/v1/otp/verify";

export const STAFF_PROFILE_PATH =
  process.env.REACT_APP_STAFF_PROFILE_PATH || "/api/v1/staff/me/profile";

export function isBackendConfigured() {
  return Boolean(BACKEND_URL);
}

export function isHrApiConfigured() {
  return Boolean(HR_API_URL);
}

export function isHostelsApiConfigured() {
  return Boolean(HOSTELS_API_URL);
}

export function isQticketApiConfigured() {
  return Boolean(QTICKET_API_URL);
}

/** Resolve absolute URL from base + path (handles /api segment overlap). */
export function resolveApiUrl(path, baseUrl = BACKEND_URL) {
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const normalizedBase = baseUrl;

  if (!normalizedBase) return normalizedPath;

  let baseHasApiSegment = false;
  try {
    baseHasApiSegment = new URL(normalizedBase).pathname
      .split("/")
      .some((segment) => segment.toLowerCase() === "api");
  } catch {
    baseHasApiSegment = /\/api(?:\/|$)/i.test(normalizedBase);
  }

  const baseEndsWithApi = /\/api$/i.test(normalizedBase);
  const pathStartsWithApi = /^\/api(?:\/|$)/i.test(normalizedPath);

  let resolvedPath = normalizedPath;
  if (baseEndsWithApi && pathStartsWithApi) {
    resolvedPath = normalizedPath.replace(/^\/api(?=\/|$)/i, "");
  } else if (!baseHasApiSegment && !pathStartsWithApi) {
    resolvedPath = `/api${normalizedPath}`;
  }

  return `${normalizedBase}${resolvedPath}`;
}
